import { Pagination as CommonPagination } from "@similarweb/ui-components";
import { getPaginationCaptionText } from "../../helpers/common";
import { StyledPagination } from "./styles";

type PaginationProps = {
    page: number;
    pageSize: number;
    totalCount: number;
    className?: string;
    onPageChange(page: number): void;
};

const Pagination = ({ page, pageSize, totalCount, className, onPageChange }: PaginationProps) => {
    return (
        <StyledPagination className={className}>
            <CommonPagination
                page={page}
                itemsCount={totalCount}
                itemsPerPage={pageSize}
                captionPosition="center"
                hasItemsPerPageSelect={false}
                handlePageChange={onPageChange}
                captionElement={getPaginationCaptionText}
            />
        </StyledPagination>
    );
}

export default Pagination;
